import { render, staticRenderFns } from "./authPricing.vue?vue&type=template&id=32001caf&scoped=true&"
import script from "./authPricing.vue?vue&type=script&lang=js&"
export * from "./authPricing.vue?vue&type=script&lang=js&"
import style0 from "./authPricing.vue?vue&type=style&index=0&id=32001caf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32001caf",
  null
  
)

export default component.exports